
module.exports.AzureTableSalesStatus = "KdsStatus";
module.exports.AzureTableCashDrawerLogs = "CashDrawerLogs";